var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-contaienr"},[_c('div',{ref:"pdfContainer",staticClass:"pdfContainer"})])}
var staticRenderFns = []
export { render, staticRenderFns }